/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Tournated Dashboard API
 * Internal REST API consumed by the Tournated dashboard. Authenticated with a user JWT (Authorization: Bearer ...).
 * OpenAPI spec version: 1.0
 */

/**
 * Geographic scope — `national`, `international`, or `local`.
 */
export type LeagueGeoScope = (typeof LeagueGeoScope)[keyof typeof LeagueGeoScope];

export const LeagueGeoScope = {
  local: "local",
  national: "national",
  international: "international",
} as const;
